import { useState } from 'react';
import { DesktopTopbarLoggedOutWrapper } from './styled';
import { useTracking } from 'react-tracking';
import { Button } from '@simplywallst/ui-core';
import loadable from '@loadable/component';
import { useTranslation } from '@/hooks/useTranslation';

const GuestRegistrationModal = loadable(
  () => import(/* webpackPrefetch: true */ '@components/GuestRegistrationModal')
);

export const DesktopTopbarLoggedOut = () => {
  const { trackEvent } = useTracking();
  const t = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <DesktopTopbarLoggedOutWrapper>
      <Button
        data-cy-id="login-signup"
        styleType="louderLarge"
        onClick={() => {
          setOpen(true);
          trackEvent({
            type: 'track',
            action: 'click',
            modifier: 'desktopTopBarLoggedOut',
            subject: 'guestRegistrationModal',
          });
        }}
      >
        {t('app.topbar.nav.account.loginOrSignup')}
      </Button>
      {open && (
        <GuestRegistrationModal
          canClose={true}
          onClose={() => {
            trackEvent({
              action: 'click',
              modifier: 'log_in_sign_up',
            });
            setOpen(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              type: 'track',
              subject: 'desktopTopBarLoggedOut',
              modifier: 'registration',
              action: 'success',
            });
          }}
        />
      )}
    </DesktopTopbarLoggedOutWrapper>
  );
};
